// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';

// ANTD
import Button from 'antd/lib/button';
import Modal from 'antd/lib/modal';
//
import CreateSessionType from '../CreateSessionType';

class SessionTypeModal extends React.Component {
  state = {
    visible: false,
  };

  toggleModal = () => {
    this.setState({ visible: !this.state.visible });
  };

  handleClick = evt => {
    evt.preventDefault();
    this.toggleModal();
  };

  render() {
    const { triggerType, clientId, buttonProps } = this.props;
    const { visible } = this.state;

    const text = '+ NEW SESSION TYPE';

    const button = (
      <Button onClick={this.handleClick} {...buttonProps}>
        {text}
      </Button>
    );

    const anchor = (
      <a href="" style={{ marginBottom: 20 }} onClick={this.handleClick} className="action-link">
        {text}
      </a>
    );

    const trigger = triggerType === 'button' ? button : anchor;

    console.log('SessionFormModal');
    console.log(this.props.sessionTypes);

    return (
      <React.Fragment>
        {' '}
        {trigger}
        <Modal
          title="Add a Session Type"
          visible={visible}
          onOk={() => console.log('helpModalOpen')}
          onCancel={this.toggleModal}
          footer={null}
        >
          <div className="flex justify-center items-center">
            <CreateSessionType toggleModal={this.toggleModal} {...this.props} />
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

SessionTypeModal.propTypes = {
  clientId: PropTypes.string.isRequired,
  buttonProps: PropTypes.object, // eslint-disable-line
};

SessionTypeModal.defaultProps = {
  buttonProps: {},
};

export default SessionTypeModal;



// WEBPACK FOOTER //
// ./src/routes/app-studio/SessionTypesArea/SessionTypeModal/index.js